import { SHARED_DIAGRAM_PAGE_PREFIX } from '../net/api';

/**
 * The token in `/s/{token}`, or `null` for any path that is not a share page.
 *
 * Exported and pure so the routing decision is testable without a browser. Deliberately strict
 * about the shape rather than merely the prefix: `/s`, `/s/`, and `/s/a/b` are all not share
 * pages, and letting any of them through would hand a garbage segment to the server as a token.
 *
 * **This lives in its own module, apart from the page it decides about, for the bundle.** The
 * decision has to be made eagerly — it is the first thing `main.ts` asks on every single page
 * load, before the router is even allowed to start — while `SharedDiagramPage` itself reaches
 * Babylon through `DiagramViewport` and is worth several megabytes. Leaving a nine-line string
 * check exported from that module meant importing all of it to ask a question whose answer is
 * `null` on every load that is not a share link, which is nearly all of them.
 */
export function sharedTokenFromPath(pathname: string): string | null {
  const prefix = `${SHARED_DIAGRAM_PAGE_PREFIX}/`;

  if (!pathname.startsWith(prefix)) {
    return null;
  }

  const rest = pathname.slice(prefix.length);

  return rest.length > 0 && !rest.includes('/') ? rest : null;
}
